<script>
export default {
  name: 'RobotIcon',
  props: {
    size: { type: [Number, String], default: 24 },
    color: { type: String, default: 'currentColor' },
  },
}
</script>

<template>
  <!-- Robô de TRAÇO, o glifo que o protótipo usa para os agentes. O set não
       tinha nenhum: `ia-head` é um rosto de 49x44 que vira borrão em 14px,
       `ai-sparkle` já significa "Agente" no segmented da sidebar e `ia-w-mark`
       é a marca AAWZ. Mesmo contrato de `tune.vue`. -->
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    >
      <path d="M12 8V4H8" />
      <rect x="4" y="8" width="16" height="12" rx="2" fill="none" />
      <path d="M2 14H4" />
      <path d="M20 14H22" />
      <path d="M9 13V15" />
      <path d="M15 13V15" />
    </g>
  </svg>
</template>
